import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgHttpLoaderModule } from 'ng-http-loader';  

import { BaseComponent } from './components/base.component';
import { DateToStringPipe } from './pipes/date-to-string.pipe';
import { DisplayErrorPipe } from './pipes/display-error.pipe';
import { CrossCuttingModule } from './crosscutting/crosscutting.module';
import { BaseService } from './services/base.service';
import { StateService } from './services/state.service';
import { GlobalEventsService } from './services/global-events.service';
import { UtilitiesService } from './services/utilities.service';



@NgModule({
  declarations: [BaseComponent, DateToStringPipe, DisplayErrorPipe],
  imports: [
    CommonModule,
    CrossCuttingModule,
 //   NgHttpLoaderModule.forRoot()
  ],
  exports: [DateToStringPipe, DisplayErrorPipe],
  providers: [
    BaseService,
    StateService,
    GlobalEventsService,
    UtilitiesService,
  ],
})
export class FrameworkModule { }
